import * as ActionTypes from "./ActionTypes";

export const UpdateBalance = (amountInCents, shouldUpdateLocalStorage) => {
  return {
    type: ActionTypes.BALANCE_UPDATE,
    amountCents: amountInCents,
    shouldUpdateLocalStorage: shouldUpdateLocalStorage
  };
};

export const AddToBalance = (amountInCents, shouldUpdateLocalStorage) => {
  return {
    type: ActionTypes.BALANCE_ADD_FUNDS,
    amountCents: amountInCents,
    shouldUpdateLocalStorage: shouldUpdateLocalStorage
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/BalanceActions.js